import { useContext, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../lib/context/AuthContext";
import Footer from "../partials/Footer/Footer";
import Header from "../partials/Header/Header";
import CircularIndeterminate from "../components/CircularIndeterminate/CircularIndeterminate";
import { useMyBusinessProfileSideBarQuery } from "../rq/hooks/useQueries";
import { readFromStorage, writeToStorage } from "../utils/storage/storage";
import uuid from "react-uuid";

const MainSharedLayout = () => {
  //hooks
  const location = useLocation();
  const navigate = useNavigate();
  const { loading, role } = useContext(AuthContext);
  const guid = uuid();
  const old_guid = readFromStorage("guid");

  //constants
  const homePage = location.pathname === "/home";
  const aboutPage = location.pathname === "/about";
  const youngTalentsPage = location.pathname === "/young-talents";

  //react query
  const { data } = useMyBusinessProfileSideBarQuery({
    enabled: role === "Business",
  });

  //effects
  useEffect(() => {
    if (data?.credits === 0) {
      navigate("/credits-purchase");
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (old_guid !== guid) writeToStorage("guid", guid);
  }, []);

  if (loading) return <CircularIndeterminate />;
  return (
    <>
      <Header />
      <Outlet />
      {(homePage || aboutPage || youngTalentsPage) && <Footer />}
    </>
  );
};

export default MainSharedLayout;
